import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export const useProfiles = () => {
  const [profiles, setProfiles] = useState([]);
  useEffect(() => {
    api.get("/profiles").then(({ data }) => setProfiles(data)).catch(() => {});
  }, []);
  return profiles;
};

export const ProfileSelect = ({ value, onChange, profiles, allowAll, testId = "profile-select" }) => (
  <Select value={value || (allowAll ? "all" : "me")} onValueChange={onChange}>
    <SelectTrigger className="w-full md:w-52 bg-white" data-testid={testId}><SelectValue /></SelectTrigger>
    <SelectContent>
      {allowAll && <SelectItem value="all">Tutta la famiglia</SelectItem>}
      <SelectItem value="me">Io</SelectItem>
      {profiles.map((p) => <SelectItem key={p.profile_id} value={p.profile_id}>{p.name} ({p.relation})</SelectItem>)}
    </SelectContent>
  </Select>
);

export const profileName = (profiles, id) => (id ? profiles.find((p) => p.profile_id === id)?.name || "—" : "Io");
